import _styled from "styled-components";
import type { SanityPageBuilderMarketoFormSection, SanityPageBuilderSection } from "@ouster/shared";
import { MarketoFormBlockView } from "~/features/blocks/inventory/marketo-form";
import { SanityMediaFigure, hasRenderableSanityMedia } from "~/features/sanity/page-builder/sections/media-figure";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderMarketoFormSection;
  };
};
export function SanityMarketoFormSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const disclaimer = sectionContent.disclaimer?.length ? <_StyledSanityRichText value={sectionContent.disclaimer} /> : undefined;
  const successMessageText = sectionContent.successMessageText?.length ? <SanityRichText value={sectionContent.successMessageText} /> : undefined;
  const successMessageImage = hasRenderableSanityMedia(sectionContent.successMessageImage) ? <SanityMediaFigure media={sectionContent.successMessageImage} sizes="lg:50vw" /> : undefined;
  return <MarketoFormBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} disclaimer={disclaimer} hasTopDivider={sectionSettings?.hasTopDivider ?? true} layout={sectionContent.layout} marketoFormId={sectionContent.marketoFormId} mode={sectionSettings?.mode || "light"} privacyCheckboxLabel={sectionContent.privacyCheckboxLabel} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} showWatchWebinarButton={sectionContent.showWatchWebinarButton} successMessage={sectionContent.successMessage} successMessageImage={successMessageImage} successMessageText={successMessageText} theme={sectionSettings?.theme || "white"} />;
}
var _StyledSanityRichText = /*#__PURE__*/_styled(SanityRichText).withConfig({
  displayName: "marketo-form___StyledSanityRichText",
  componentId: "sc-l66i9w-0"
})({
  "marginBottom": "1.6rem",
  "fontSize": "1.33rem",
  "--tw-text-opacity": "1",
  "color": "rgb(92 92 92 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "marginBottom": "2.4rem"
  }
});